import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progress"]
  static values = {
    type: { type: String, default: "info" },
    dismissAfter: { type: Number, default: 4000 }
  }

  connect() {
    this.element.classList.add("animate-slide-in-right")

    if (this.dismissAfterValue > 0) {
      if (this.hasProgressTarget) {
        this.progressTarget.style.animationDuration = `${this.dismissAfterValue}ms`
        this.progressTarget.classList.add("animate-progress-shrink")
      }
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }

    this._handleTouchStart = this._onTouchStart.bind(this)
    this._handleTouchMove = this._onTouchMove.bind(this)
    this._handleTouchEnd = this._onTouchEnd.bind(this)
    this.element.addEventListener("touchstart", this._handleTouchStart, { passive: true })
    this.element.addEventListener("touchmove", this._handleTouchMove, { passive: false })
    this.element.addEventListener("touchend", this._handleTouchEnd)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.removeEventListener("touchstart", this._handleTouchStart)
    this.element.removeEventListener("touchmove", this._handleTouchMove)
    this.element.removeEventListener("touchend", this._handleTouchEnd)
  }

  dismiss() {
    this.element.classList.remove("animate-slide-in-right")
    this.element.classList.add("animate-slide-out-right")
    this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
  }

  _onTouchStart(event) {
    this._touchStartX = event.changedTouches[0].clientX
    this._touchStartY = event.changedTouches[0].clientY
  }

  _onTouchMove(event) {
    if (!this._touchStartX) return
    const deltaX = event.changedTouches[0].clientX - this._touchStartX
    const deltaY = Math.abs(event.changedTouches[0].clientY - this._touchStartY)

    if (deltaX > 0 && deltaX > deltaY) {
      event.preventDefault()
      this.element.style.transform = `translateX(${deltaX}px)`
      this.element.style.opacity = `${1 - deltaX / 200}`
    }
  }

  _onTouchEnd(event) {
    if (!this._touchStartX) return
    const deltaX = event.changedTouches[0].clientX - this._touchStartX

    if (deltaX > 80) {
      this.dismiss()
    } else {
      this.element.style.transform = ""
      this.element.style.opacity = ""
    }
    this._touchStartX = null
    this._touchStartY = null
  }
}
